// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-module--icon--3E2k-","small":"Icon-module--small--2NrKR","medium":"Icon-module--medium--1OT2s","large":"Icon-module--large--3obGd"};